export class RelatoriosPriceDTO {
  public idEmpregadores!: number;
  public idPromotoras!: number;
  public dtCadastroInicio!: Date;
  public dtCadastroFim!: Date;
}